import React, { useState } from "react";
import Button from "../../common/components/Button";
import PropTypes from "prop-types";
import LoadingSpinner from "../../common/components/LoadingSpinner";

const StimTable = ({ loading, data, onAddAll }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  if (loading) {
    return (
      <LoadingSpinner
        style={{ margin: "80px auto", position: "relative", top: "unset" }}
      />
    );
  }

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleAddAll = async () => {
    if (isAdding) return;

    const idsToAdd = selectedIds.slice();
    if (idsToAdd.length === 0) return;

    try {
      setIsAdding(true);
      const res = await Promise.resolve(onAddAll(idsToAdd));
      setSelectedIds([]);
    } finally {
      setIsAdding(false);
    }
  };
  const disabled = selectedIds.length === 0 || isAdding;

  return (
    <div>

      <div style={{ marginBottom: 16, textAlign: "right" }}>
        <button
          type="button"
          className="button-secondary"
          onClick={handleAddAll}
          disabled={disabled}
          style={{
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          {isAdding ? "Adding..." : "Add All"}
        </button>
      </div>

      <table
        style={{ overflow: "initial", padding: "0px" }}
        className="table study"
      >
        <tbody>
          <tr>
            <th>Select</th>
            <th>Id</th>
            <th style={{ width: "100%" }}>Name</th>
            <th>Type</th>
            <th>Adtype</th>
            <th>Media</th>
            <th>Dimension</th>
          </tr>
          {data.map((item, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  style={{
                    width: "16px",
                    height: "16px",
                    visibility: "visible",
                    display: "inline-block",
                  }}
                  checked={selectedIds.includes(item.id)}
                  onChange={() => toggleSelect(item.id)}
                />
              </td>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.type}</td>
              <td>{item.adtype}</td>
              <td>{item.media}</td>
              <td>{`${item.width} x ${item.height}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

StimTable.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  onAddAll: PropTypes.func,
};

export default StimTable;
